module.exports = __webpack_public_path__ + "static/media/Offers_Selected@3x.ff4b531f.png";